import React from 'react';
import HomePage from './pages/HomePage';
import AnalyticsTablePage from './pages/AnalyticsTablePage';
import SummaryTablePage from './pages/SummaryTablePage';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import HrTablePage from './pages/HrTablePage';
import LoginPage from './pages/LoginPage';
import OrganisationPage from './pages/OrganisationPage';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from 'react-query';
import { AuthProvider } from './components/AutheticationContext';
import ProtectedRoute from './components/ProtectedRoute';
import LoadingSpinner from './components/LoadingSpinner';
import RegistrationPage from './pages/RegistrationPage';
import SuccessfulRegistration from './pages/SuccessfulRegistration';

const queryClient = new QueryClient();

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <>
        <ToastContainer 
          position="top-right"
          autoClose={5000}
          closeOnClick
          pauseOnHover
          draggable
        />
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/registration" element={<RegistrationPage />} />
          <Route path="/success-registration" element={<SuccessfulRegistration />} />


          {/* Protected routes */}
          <Route 
            element={
              <ProtectedRoute 
                fallback={<LoadingSpinner message="Verifying your session..." />} 
              />
            }
          >
            <Route path="/" element={<Navigate to="/summary" replace />} />
            <Route path="/summary" element={<SummaryTablePage />} />
            <Route path="/hr" element={<HrTablePage />} />
            <Route path="/analytics" element={<AnalyticsTablePage />} />
            <Route path="/structure" element={<OrganisationPage />} />
          </Route>
          
          {/* Fallback route - redirect to summary or login if not authenticated */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
      </>
    </QueryClientProvider>
  );
}
